export class User {
  email = "";
  entityId = 0;
  firstName = "";
  lastName = "";
  loggedIn = false;
  static production = process.env.NODE_ENV === "development" ? false : true;
  password = "";
  confirmPassword = "";
}
